import * as React from "react";
type Props = {
  className?: string,
};
function SvgPause({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-pause"
      className={className}
    >
      <path
        d="M9.42859 6.75V17.25M14.5714 6.75V17.25"
        stroke="currentColor"
        strokeWidth={2}
      />
    </svg>
  );
}
export default SvgPause;
